import React from "react";
import { Row, Col } from "react-bootstrap";
import "./CareerBoosterBenefits.css";

function CareerBoosterBenefits() {
  return (
    <div className="career-benefits-parent-section">
      {/* Main Section Header */}
      <h2 className="section-title">
        How job seekers have benefitted from the service
      </h2>

      {/* Grid Display Container */}
      <div className="benefits-card-wrapper">
        
        {/* Decorative Floating User Avatars (Background Layer) */}
        <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=faces" alt="user1" className="floating-avatar avatar-top-left" />
        <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=faces" alt="user2" className="floating-avatar avatar-bottom-left" />
        <img src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&h=100&fit=crop&crop=faces" alt="user3" className="floating-avatar avatar-center-mid" />
        <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces" alt="user4" className="floating-avatar avatar-top-right" />
        <img src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop&crop=faces" alt="user5" className="floating-avatar avatar-bottom-right" />
        <img src="https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?w=100&h=100&fit=crop&crop=faces" alt="user6" className="floating-avatar avatar-far-right" />

        {/* Dynamic Foreground Split Info Content */}
        <Row className="g-0 content-row-layer align-items-center">
          
          {/* Left Column Metric */}
          <Col md={6} className="metric-column border-end-divider">
            <h3 className="metric-number text-purple">
              1200 <span className="metric-label text-dark">users</span>
            </h3>
            <p className="metric-description text-dark">
              have used <strong>Career Booster</strong> over the past six months
            </p>
          </Col>

          {/* Right Column Metric */}
          <Col md={6} className="metric-column right-side-padding">
            <h3 className="metric-number text-orange">
              56% rise <span className="trend-arrow">↗</span>
            </h3>
            <p className="metric-description text-dark">
              in profile views
            </p>
          </Col>

        </Row>
      </div>
    </div>
  );
}

export default CareerBoosterBenefits;